import { decryptPassword } from '@/Utils/cryptoUtils';
import store from '@/store';

import { chunkMessage, encryptWithPublicKey } from './P2PHelper';
import { getUUID } from './getUuid';
import { sendP2PSocketData } from './p2pConnection';

export const encryptServerKeyHandler = async (
    dataRec: {
        user_id: string;
        uuid: string;
        sign: string;
        encrypted_key: string;
    },
    source: string,
) => {
    const dataJson = dataRec;
    const activeServer = store.getState().serverDataReducer.activeServer;

    const serverData =
        store.getState().serverDataReducer.serverData?.[activeServer];

    const privateKey = serverData?.privateKey;
    const publicKey = serverData?.publicKey;

    const uuids = await getUUID();

    if (privateKey && publicKey) {
        let decryptedJWKPublic: any = decryptPassword(publicKey);
        let decryptedJWKPrivate: any = decryptPassword(privateKey);

        let keysObject = {
            publicKey: decryptedJWKPublic,
            privateKey: decryptedJWKPrivate,
        };

        const message = JSON.stringify(keysObject);

        const chunkSize = 50;
        const chunks = chunkMessage(message, chunkSize);

        const encryptedChunks = [];
        for (const chunk of chunks) {
            const encryptedChunk = await encryptWithPublicKey(
                chunk,
                dataJson.encrypted_key,
            );
            encryptedChunks.push(encryptedChunk);
        }

        sendP2PSocketData({
            command: 'send_msg',
            data: {
                client_event: 'sent_keys',
                uuid: uuids[0].uuid,
                encrypted_key: JSON.stringify(encryptedChunks),
            },
        });
        setTimeout(() => {
            sendP2PSocketData({
                command: 'disconnect_peer',
                data: source,
            });
        }, 3000);
    }
};
